import { useMemo } from 'react';
import useBrokenImageUrls from './useBrokenImageUrls';
import getValidImageUrls from './getValidImageUrls';

const useRemoveBrokenImageUrls = imageUrls => {
  const brokenImageUrls = useBrokenImageUrls();

  const validImageUrls = useMemo(
    () => getValidImageUrls(imageUrls, brokenImageUrls),
    [imageUrls, brokenImageUrls]
  );

  return validImageUrls;
};

export default useRemoveBrokenImageUrls;
